import React from 'react';
import { useNavigate } from 'react-router-dom';
import useIsMobile from '../hooks/useIsMobile';

interface MobileHeaderProps {
  onMenuToggle: () => void;
  title?: string;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({ onMenuToggle, title = 'LLM Playground' }) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  if (!isMobile) return null;

  return (
    <div className="mobile-header">
      <button 
        className="menu-toggle"
        onClick={onMenuToggle}
      >
        ☰
      </button>
      <div className="logo" onClick={() => navigate('/')}>
        {title}
      </div>
    </div>
  );
};

export default MobileHeader;